<template>
  <div class="the-media" :class="[rClass, `align-${align}`, `justify-${justify}`]">
    <div class="the-media-left" v-if="left">
      <slot name="left" />
    </div>
    <div class="the-media-body">
      <slot name="body" />
    </div>
    <div class="the-media-right" v-if="right">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PfMediaObject',
  props: {
    /**
     * Custom class
     */
    rClass: String,
    /**
     * media left side
     */
    left: Boolean,
    /**
     * media right side
     */
    right: Boolean,
    /**
     * align variants
     */
    align: {
      type: String,
      default: 'top',
      validator: function (value) {
        return ['top', 'bottom', 'center'].indexOf(value) !== -1;
      },
    },
    /**
     * justify variants
     */
    justify: {
      type: String,
      default: 'start',
      validator: function (value) {
        return ['start', 'end', 'center'].indexOf(value) !== -1;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
$space: var(--spacer-xs);

.the-media {
  display: flex;

  &.align-top {
    align-items: flex-start;
  }

  &.align-bottom {
    align-items: flex-end;
  }

  &.align-center {
    align-items: center;
  }

  &.justify-start {
    justify-content: flex-start;
  }

  &.justify-end {
    justify-content: flex-end;
  }

  &.justify-center {
    justify-content: center;
  }

  .the-media-left {
    padding-right: $space;
  }

  .the-media-right {
    padding-left: $space;
  }

  .the-media-center,
  .the-media-body {
    flex: 1 1 0;
  }
}
</style>
